import { getProfileDetails, updateMenagerPercentage } from "../js/api/profile.js";

// const expire_ttl = ((60 * 60 * 24) * 7) * 1000; // 1 day => 86400 seconds // 7 days total
const expire_ttl = (60 * 60 * 3.5) * 1000; // 3.5 hours total

const checkForUserGroup = async () => {
  if(!localStorage.getItem('access_token')) return;

  const now = new Date().getTime();

  let needsRefresh = true;
  const expiry = localStorage.getItem('profiledetails_expiry');
  if (expiry && !isNaN(expiry)) {
      const _expiry = JSON.parse(expiry);
      needsRefresh = now > _expiry;
  }

  if (needsRefresh === true) {
    const profileDetails = await getProfileDetails();
    if(profileDetails && profileDetails.length > 0) {
      localStorage.setItem('profiledetails', JSON.stringify(profileDetails));
      const expire_time =  now + expire_ttl;
      localStorage.setItem('profiledetails_expiry', expire_time);

      const profile_id = profileDetails[0]['profile_id'];
      localStorage.setItem('profiledetails_profile_id', profile_id);
    }
  }

  return needsRefresh;
}

const getUserGroup = () => {
  const storedUserGroup = localStorage.getItem('profiledetails');
  if(!storedUserGroup) {
    return null;
  }

  const userGroup = JSON.parse(storedUserGroup);
  if (!userGroup || !Array.isArray(userGroup) || userGroup.length === 0) {
    return null
  }
  
  return userGroup;
}

const transformMarkets = (markets) => {
  if (!markets) return markets;

  const minOdd = getMinOdd();
  if (minOdd > 1) {
    markets.forEach(market_group => {
      if(market_group.length > 0) {
        market_group = market_group.forEach(market => {
          if (parseFloat(market.odd) < minOdd) {
            market.odd = '1.00';
          }
        });
      }
    })
  }
  
  let result = markets;

  try {
    const userGroup = getUserGroup();
    if (!userGroup) return result;

    
    result = markets.map(market_group => {
      if(market_group.length > 0) {
        market_group = market_group.map(market => {
          let odd = 1;
          const userGroupMarket = userGroup.find(ug => ug.market_id === market.market_id.toString());
          const default_percentage = parseFloat(userGroup[0].default_percentage);
          const market_percentage = userGroupMarket ? parseFloat(userGroupMarket.market_percentage) : null;
          const percentage = market_percentage ? market_percentage : default_percentage;
  
          if (!percentage || percentage === 1) {
            return market;
          }

          const odd_start = parseFloat(market.odd);
          if (odd_start <= 1) return market;  // if initial odd is equal or lower than 1

          odd = odd_start * percentage;
          if(odd < 1) odd = 1; // if new odd is lower than 1
          console.log('Batch (prev, next): ', odd_start, odd.toFixed(2), `Market ID: ${market.market_id}`, `Market %: ${userGroupMarket?.market_percentage}`, `Default %: ${userGroup[0].default_percentage}`);

          market.odd = odd.toFixed(2);
          return market;
        });
      }
      return market_group;
    })
  } catch (e) {
    console.error(e);
  }

  return result;
}

const transformGamesWithJoinedOdds = (games) => {
  if (!games) return games;

  const minOdd = getMinOdd();
  if (minOdd > 1) {
    games.forEach(game => {
      if (game.odd === null) return;
      let gameMarkets = game.odd.split(',');
      if (gameMarkets.length === 0) return;
      gameMarkets = gameMarkets.map(market => {
        if (market === null) return;
        const marketOptions = market.split('|');
        if (marketOptions.length < 3) return;

        const odd = parseFloat(marketOptions[1]);
        if (odd < minOdd) {
          marketOptions[1] = '1.00';
        }
        return marketOptions.join('|');
      });

      game.odd = gameMarkets.join(',');
    });
  }
  
  let result = games;

  try {
    const userGroup = getUserGroup();
    if (!userGroup) return result;

    result = games.map(game => {
      // console.log('Before', game.odd);
      if (game.odd === null) return game;
      let gameMarkets = game.odd.split(',');
      if (gameMarkets.length === 0) return game;

      gameMarkets = gameMarkets.map(market => {
        if (market === null) return market;
        const marketOptions = market.split('|');
        if (marketOptions.length < 3) return market;
        
        let odd = 1;
        const userGroupMarket = marketOptions[3] ? userGroup.find(ug => ug.market_id === marketOptions[3]) : null;
        const default_percentage = parseFloat(userGroup[0].default_percentage);
        const market_percentage = userGroupMarket ? parseFloat(userGroupMarket.market_percentage) : null;
        const percentage = market_percentage ? market_percentage : default_percentage;

        if (!percentage || percentage === 1) {
          return market;
        }

        const odd_start = parseFloat(marketOptions[1]);
        if (odd_start <= 1) return market; // if initial odd is equal or lower than 1
        
        odd = odd_start * percentage;
        if(odd < 1) odd = 1; // if new odd is lower than 1

        // console.log('Batch Merged (prev, next): ', odd_start, odd.toFixed(2));
        marketOptions[1] = odd.toFixed(2);
        return marketOptions.join('|');
      });

      game.odd = gameMarkets.join(',');
      // console.log('After', game.odd);
      return game;
    });
  } catch (e) {
    console.error(e);
  }

  return result;
}

const transformSingleCoef = (coef, userGroup) => {
  const minOdd = getMinOdd();
  if (minOdd > 1 && parseFloat(coef.odd) < minOdd) {
    coef.odd = '1.00';
  }

  if(!userGroup) return coef;

  try {
    let odd = 1;
    const userGroupMarket = userGroup.find(ug => ug.market_id === coef.market_id);
    const default_percentage = parseFloat(userGroup[0].default_percentage);
    const market_percentage = userGroupMarket ? parseFloat(userGroupMarket.market_percentage) : null;
    const percentage = market_percentage ? market_percentage : default_percentage;

    if (!percentage || percentage === 1) {
      return coef;
    }

    let odd_start = parseFloat(coef.odd);
    if (odd_start <= 1) return coef; // if initial odd is equal or lower than 1

    odd = odd_start * percentage;
    if(odd < 1) odd = 1;
  
    // console.log('Single (prev, next): ', odd_start, odd.toFixed(2));
    coef.odd = odd.toFixed(2);
    return coef;
  } catch (e) {
    console.error(e);
    return coef;
  }
}

const transformRepeatBet = (games) => {
  if (!games) return games;
  
  let result = games;

  try {
    const userGroup = getUserGroup();
    if (!userGroup) return result;


    result = games.map(game => {
      let matchMarket = game.matchMarket;

      let odd = 1;
      const userGroupMarket = userGroup.find(ug => ug.market_id === matchMarket);
      const default_percentage = parseFloat(userGroup[0].default_percentage);
      const market_percentage = userGroupMarket ? parseFloat(userGroupMarket.market_percentage) : null;
      const percentage = market_percentage ? market_percentage : default_percentage;

      if (!percentage || percentage === 1) {
        return game;
      }

      const odd_start = parseFloat(game.coefVal);
      if (odd_start <= 1) return game; // if initial odd is equal or lower than 1

      odd = odd_start * percentage;
      if(odd < 1) odd = 1; // if new odd is lower than 1

      game.coefVal = odd.toFixed(2);

      return game;
    });
  } catch {
    console.error(e);
  }
  
  return result;
}

const getMinOdd = () => {
  const minOdd = localStorage.getItem("min_odd");
  if (!minOdd) return null;

  // Check if string is number
  if (!isNaN(minOdd)) {
    return parseFloat(minOdd);
  }

  return null;
};

export {
  checkForUserGroup,
  getUserGroup,
  transformMarkets,
  transformGamesWithJoinedOdds,
  transformSingleCoef,
  transformRepeatBet
}